/* Thème Rendez-vous — vanilla JS, zéro dépendance. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var header = document.querySelector('.site-header');

    /* ---------- Header : état scrollé (fond + logo compact) ---------- */
    var panelsWrap = document.querySelector('.hero-panels');

    function computeScrolled() {
      /* Sur l'accueil le scroll vit dans le conteneur de panneaux,
         mais le body scrolle aussi une fois les panneaux passés. */
      var inPanels = panelsWrap ? panelsWrap.scrollTop > 40 : false;
      return inPanels || window.scrollY > 10;
    }
    function syncScrolledState() {
      if (!header) return;
      /* Tant que le pager tient la barre, lui seul décide de l'état du
         header (logo + fond). Évite deux systèmes qui s'écrasent. */
      if (header.classList.contains('pager-active')) return;
      header.classList.toggle('is-scrolled', computeScrolled());
    }

    if (panelsWrap) {
      panelsWrap.addEventListener('scroll', syncScrolledState, { passive: true });
    }
    window.addEventListener('scroll', syncScrolledState, { passive: true });
    syncScrolledState();

    /* ---------- Méga-menu ---------- */
    var menu = document.getElementById('MegaMenu');
    if (menu) {
      /* cascade : indexer les items pour le délai d'apparition */
      menu.querySelectorAll('.mega-menu__item').forEach(function (item, i) {
        item.style.setProperty('--stagger-i', i);
      });
    }
    /* Images du menu : posées seulement quand on s'apprête à l'ouvrir
       (voir header.liquid). Le survol / le toucher du bouton suffit, pour
       qu'elles soient déjà là quand le panneau glisse. */
    function loadMenuImages() {
      if (!menu) return;
      menu.querySelectorAll('img[data-menu-src]').forEach(function (img) {
        img.srcset = img.getAttribute('data-menu-srcset');
        img.src = img.getAttribute('data-menu-src');
        img.removeAttribute('data-menu-src');
      });
    }
    ['pointerover', 'touchstart', 'focusin'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        if (e.target.closest && e.target.closest('[data-menu-open]')) loadMenuImages();
      }, { passive: true });
    });

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-menu-open]');
      var closer = e.target.closest('[data-menu-close]');
      var expander = e.target.closest('[data-menu-expand]');
      if (opener && menu) {
        loadMenuImages();
        menu.classList.add('is-open');
        if (header) header.classList.add('menu-open');
        document.body.style.overflow = 'hidden';
      }
      if ((closer || e.target.classList.contains('mega-menu__backdrop')) && menu) {
        menu.classList.remove('is-open');
        if (header) header.classList.remove('menu-open');
        document.body.style.overflow = '';
      }
      if (expander) {
        expander.closest('.mega-menu__item').classList.toggle('is-expanded');
      }
      /* Panneau de filtres (collection) */
      var filterPanel = document.getElementById('FilterPanel');
      if (filterPanel) {
        if (e.target.closest('[data-filters-open]')) filterPanel.classList.add('is-open');
        if (e.target.closest('[data-filters-close]')) filterPanel.classList.remove('is-open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (menu) menu.classList.remove('is-open');
        var drawer = document.getElementById('CartDrawer');
        if (drawer) drawer.classList.remove('is-open');
        if (header) header.classList.remove('menu-open');
        document.body.style.overflow = '';
      }
    });

    /* ---------- Reveal on scroll (+ stagger dans les grilles) ---------- */
    document.querySelectorAll('.mosaic-grid, .results-grid, .associer-grid').forEach(function (grid) {
      var i = 0;
      grid.querySelectorAll('.reveal').forEach(function (el) {
        el.style.setProperty('--stagger-i', i % 4);
        i++;
      });
    });

    var inEditor = window.Shopify && window.Shopify.designMode;
    var revealObserver = null;
    if ('IntersectionObserver' in window && !reducedMotion && !inEditor) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
    }

    /* Observe les éléments d'un périmètre donné. Dans l'éditeur (ou sans
       observer), on les rend visibles tout de suite : sans cela une section
       fraîchement ajoutée resterait à opacity 0, donc totalement blanche. */
    function initReveals(scope) {
      var root = scope || document;
      root.querySelectorAll('.reveal, .reveal-text').forEach(function (el) {
        if (revealObserver) revealObserver.observe(el);
        else el.classList.add('is-visible');
      });
    }
    initReveals(document);

    /* Carrousels d'un périmètre donné (flèches) */
    function initCarousels(scope) {
      (scope || document).querySelectorAll('[data-carousel]').forEach(function (root) {
        if (root.dataset.carouselReady) return;
        root.dataset.carouselReady = '1';
        var track = root.querySelector('[data-carousel-track]');
        if (!track) return;
        root.querySelectorAll('[data-carousel-prev]').forEach(function (b) {
          b.addEventListener('click', function () {
            track.scrollBy({ left: -track.clientWidth * 0.6, behavior: reducedMotion ? 'auto' : 'smooth' });
          });
        });
        root.querySelectorAll('[data-carousel-next]').forEach(function (b) {
          b.addEventListener('click', function () {
            track.scrollBy({ left: track.clientWidth * 0.6, behavior: reducedMotion ? 'auto' : 'smooth' });
          });
        });

        /* Barre de défilement : la longueur du curseur est la part visible
           du contenu, sa position suit scrollLeft. Le curseur est mis à
           l'échelle PUIS déplacé : le translateX s'exprime alors dans le
           repère déjà réduit, il faut le diviser par l'échelle pour qu'il
           reste en pixels de rail. Masquée quand tout tient à l'écran. */
        var bar = root.querySelector('[data-carousel-bar]');
        if (bar) {
          var thumb = bar.querySelector('.carousel-bar__thumb');
          var poserBarre = function () {
            var max = track.scrollWidth - track.clientWidth;
            if (max <= 1) { bar.hidden = true; return; }
            bar.hidden = false;
            var taille = track.clientWidth / track.scrollWidth;
            var pos = (track.scrollLeft / max) * (1 - taille) * bar.clientWidth / taille;
            thumb.style.setProperty('--bar-size', taille.toFixed(4));
            thumb.style.setProperty('--bar-pos', pos.toFixed(1) + 'px');
          };
          track.addEventListener('scroll', poserBarre, { passive: true });
          window.addEventListener('resize', poserBarre, { passive: true });
          window.addEventListener('load', poserBarre);
          poserBarre();
        }

        /* Démarrage au centre : on se place au milieu du track pour pouvoir
           défiler à gauche comme à droite dès l'arrivée. */
        if (root.hasAttribute('data-carousel-center')) {
          var centerTrack = function () {
            var max = track.scrollWidth - track.clientWidth;
            if (max > 0) track.scrollLeft = max / 2;
          };
          centerTrack();
          requestAnimationFrame(centerTrack);
          window.addEventListener('load', centerTrack);
        }
      });
    }

    /* L'éditeur de thème recharge les sections : on ré-initialise. */
    document.addEventListener('shopify:section:load', function (e) {
      initReveals(e.target);
      initCarousels(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      initReveals(e.target);
    });

    /* ---------- Panneaux plein écran : pager « page qui tourne » ----------
       Une page entière par geste (molette, swipe, clavier). Le track glisse
       en translateY sur une durée réglable, easing type livre ; pendant le swipe,
       le panneau suit le doigt puis se cale. Après le dernier panneau, le
       geste rend la main au scroll normal de la page ; en remontant tout en
       haut, le pager reprend la main. */
    if (panelsWrap) {
      var track = panelsWrap.querySelector('.hero-panels__track');
      var panels = panelsWrap.querySelectorAll('.hero-panel');

      /* Un panneau entier est cliquable : sans garde-fou, le geste qui
         tourne la page se terminerait par une navigation, puisque le doigt
         se lève sur le lien de couverture. On retient le déplacement et on
         annule le clic au-delà de quelques pixels. Capté à la descente,
         donc avant que le lien ne réagisse. */
      var depart = null;
      var aGlisse = false;
      panelsWrap.addEventListener('touchstart', function (e) {
        depart = e.touches[0];
        aGlisse = false;
      }, { passive: true });
      panelsWrap.addEventListener('touchmove', function (e) {
        if (!depart) return;
        var dx = Math.abs(e.touches[0].clientX - depart.clientX);
        var dy = Math.abs(e.touches[0].clientY - depart.clientY);
        if (dx > 10 || dy > 10) aGlisse = true;
      }, { passive: true });
      panelsWrap.addEventListener('click', function (e) {
        if (!aGlisse) return;
        e.preventDefault();
        e.stopPropagation();
        aGlisse = false;
      }, true);
      var counter = panelsWrap.querySelector('[data-panel-counter]');

      /* Affiche la variante de monogramme demandée (classe explicite). */
      var setMonogram = function (key) {
        if (!header) return;
        header.querySelectorAll('.logo-variant').forEach(function (v) {
          v.classList.toggle('is-visible', v.getAttribute('data-logo-key') === key);
        });
      };

      var activatePanel = function (i) {
        panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
        if (counter) counter.textContent = (i + 1) + ' / ' + panels.length;
        panelsWrap.classList.toggle('is-past-first', i > 0);
        /* Trois états : wordmark (typo géante), mono_dark, mono_light.
           `logo-giant` déploie la typo ; sans cette classe, header normal. */
        if (header) {
          var mode = panels[i].getAttribute('data-logo') || 'mono_light';
          header.setAttribute('data-logo-active', mode);
          header.classList.toggle('logo-giant', mode === 'wordmark');
          setMonogram(mode === 'mono_light' ? 'mono_light' : 'mono_dark');
          /* Le texte et les icônes du header suivent la même teinte */
          header.setAttribute('data-tint', panels[i].getAttribute('data-tint') || 'light');
        }
        /* Le compteur et l'invite suivent la même teinte : blancs sur un
           panneau sombre, encre sur un panneau clair. Sans cela ils
           restaient blancs partout, donc invisibles sur les tuiles. */
        panelsWrap.setAttribute('data-tint', panels[i].getAttribute('data-tint') || 'light');
      };

      /* Dans l'éditeur de thème, le pager ne prend jamais la main :
         sinon toute section ajoutée sous les panneaux devient
         invisible et impossible à modifier. */
      var designMode = window.Shopify && window.Shopify.designMode;

      if (!track || reducedMotion || panels.length < 2 || designMode) {
        /* Repli : défilement natif */
        panelsWrap.classList.add('hero-panels--static');
        panels.forEach(function (p) { p.classList.add('is-active'); });
        if (header) {
          header.classList.remove('logo-giant');
          header.setAttribute('data-tint', 'dark');
        }
        document.documentElement.style.overflow = '';
      } else {
        /* Fluidité « à la TikTok » (V61) :
           - courbe qui DÉMARRE vite puis freine (ease-out) : le panneau
             bouge dès le geste, sans le temps mort d'un ease-in-out ;
           - au doigt, le panneau suit à 100 % ; au lâcher, la vitesse du
             geste compte : un petit coup sec suffit à tourner la page ;
           - la fin d'animation repart de la position réelle, et sa durée
             se règle sur la distance restante ;
           - aucun verrou : un geste peut interrompre une transition en
             cours. Seule la molette ignore la traîne d'inertie du pavé
             tactile (un geste = une page).
           Positions en pixels (translate3d), lues dans la matrice calculée
           quand il faut reprendre un mouvement en cours. */
        /* Décélération douce, comme le défilement par pages d'iOS (courbe
           « ease-out quad »). Sa pente de départ vaut 1,84 (0,46 / 0,25) :
           pour un swipe réel (1,5–3 px/ms) et une page d'écran, la durée qui
           fait repartir la page à la vitesse du doigt tombe dans 320–650 ms.
           Une courbe plus raide (pente 4 ou plus) faisait partir la page
           plus vite que le doigt : effet de saut. */
        var EASE = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        var EASE_SLOPE = 1.84;
        var DURATION = parseInt(panelsWrap.getAttribute('data-panel-duration'), 10) || 550;
        var index = 0;
        var animating = false;
        var animTimer = null;
        var released = false; /* true = la page scrolle normalement */
        var lastIndex = panels.length - 1;

        var panelH = function () { return panelsWrap.clientHeight || window.innerHeight; };
        var setY = function (y, ms) {
          track.style.transition = ms ? 'transform ' + ms + 'ms ' + EASE : 'none';
          track.style.transform = 'translate3d(0,' + y + 'px,0)';
        };
        var readY = function () {
          var t = getComputedStyle(track).transform;
          if (!t || t === 'none') return -index * panelH();
          return new DOMMatrixReadOnly(t).m42;
        };

        var lockBody = function () {
          document.documentElement.style.overflow = 'hidden';
          panelsWrap.classList.add('is-pinned');
          if (header) {
            header.classList.add('pager-active');
            header.classList.remove('is-scrolled');
          }
        };
        /* Sortie vers le reste de la page (V63) : avant, la vue sautait
           d'un coup sous les panneaux. Le conteneur reprend sa place dans le
           flux, la vue est posée sur le dernier panneau (identique à l'écran,
           donc sans saut), puis la page défile en douceur jusqu'au contenu
           suivant, avec la même décélération que les panneaux. Un toucher ou
           un coup de molette pendant ce défilement l'arrête. */
        var exitRaf = null;
        var exitStartedAt = 0;
        var exitLastWheel = 0;
        var stopExit = function () {
          if (exitRaf) { window.cancelAnimationFrame(exitRaf); exitRaf = null; }
        };
        /* Seul un NOUVEAU geste interrompt la sortie : pas la traîne
           d'inertie de la molette qui l'a déclenchée (événements à moins
           de 160 ms d'écart), ni la touche qui vient de la lancer. */
        window.addEventListener('touchstart', stopExit, { passive: true });
        window.addEventListener('wheel', function () {
          var now = performance.now();
          var gap = now - exitLastWheel;
          exitLastWheel = now;
          if (gap >= 160 && now - exitStartedAt > 160) stopExit();
        }, { passive: true });
        window.addEventListener('keydown', function () {
          if (performance.now() - exitStartedAt > 100) stopExit();
        });
        var smoothExit = function (from, to, ms) {
          stopExit();
          exitStartedAt = performance.now();
          var t0 = null;
          var step = function (now) {
            if (t0 === null) t0 = now;
            var p = Math.min(1, (now - t0) / ms);
            var eased = p * (2 - p); /* ease-out quad, comme EASE */
            window.scrollTo(0, from + (to - from) * eased);
            exitRaf = p < 1 ? window.requestAnimationFrame(step) : null;
          };
          exitRaf = window.requestAnimationFrame(step);
        };
        var unlockBody = function () {
          document.documentElement.style.overflow = '';
          panelsWrap.classList.remove('is-pinned');
          var top = panelsWrap.offsetTop;
          window.scrollTo(0, top);
          smoothExit(top, top + panelsWrap.offsetHeight, Math.max(DURATION, 600));
          if (header) {
            header.classList.remove('pager-active');
            /* Retour au header classique : monogramme noir, fond plein */
            header.setAttribute('data-logo-active', 'mono_dark');
            header.classList.remove('logo-giant');
            header.setAttribute('data-tint', 'dark');
            setMonogram('mono_dark');
            header.classList.add('is-scrolled');
          }
        };

        var go = function (i, ms) {
          i = Math.max(0, Math.min(lastIndex, i));
          var changed = i !== index;
          index = i;
          var d = ms == null ? DURATION : ms;
          animating = true;
          setY(-i * panelH(), d);
          if (changed || !panels[i].classList.contains('is-active')) activatePanel(i);
          window.clearTimeout(animTimer);
          animTimer = window.setTimeout(function () { animating = false; }, d);
        };

        var release = function () {
          released = true;
          unlockBody();
        };
        var recapture = function () {
          released = false;
          stopExit();
          lockBody();
          /* Retour depuis le bas de page (V65) : on reprend la main sur le
             panneau à l'écran — le dernier — sans changer de page ; la
             position est recalée sur la hauteur épinglée. */
          index = lastIndex;
          setY(-lastIndex * panelH(), 0);
          activatePanel(lastIndex);
        };

        /* Molette / pavé tactile : un geste = une page.
           Un NOUVEAU geste se reconnaît (V66) :
           - après une pause de 160 ms sans événement ;
           - OU, sans pause, quand le pavé tactile enchaîne les gestes et
             que l'élan du précédent n'est pas fini (relevé réel : 356
             événements en 2,3 s, jamais plus de 49 ms d'écart, pour 4
             gestes) : le sens s'inverse, ou bien l'amplitude, retombée
             après son pic, remonte nettement (> creux × 2 + 4, et ≥ 10).
           L'amplitude est la médiane des 3 derniers événements : les pics
           isolés de l'inertie (un 83 au milieu de 20) sont ignorés. */
        var wheelLocked = false;
        var lastWheel = 0;
        var wheelHist = [];
        var wheelPeak = 0;
        var wheelTrough = Infinity;
        var wheelDir = 0;
        var wheelOpposite = 0;
        var lastTrigger = 0;
        var wheelMedian = function (v) {
          wheelHist.push(v);
          if (wheelHist.length > 3) wheelHist.shift();
          var a = wheelHist.slice().sort(function (x, y) { return x - y; });
          return a[Math.floor(a.length / 2)];
        };
        var isNewWheelGesture = function (dy, gap, now) {
          if (gap >= 160) { wheelHist = []; wheelOpposite = 0; return true; }
          var m = wheelMedian(Math.abs(dy));
          var dir = dy > 0 ? 1 : -1;
          if (now - lastTrigger < 250) return false;
          if (wheelDir && dir !== wheelDir && Math.abs(dy) >= 4) {
            wheelOpposite++;
            if (wheelOpposite >= 2) return true;
          } else {
            wheelOpposite = 0;
          }
          if (m > wheelPeak) wheelPeak = m;
          if (m < wheelPeak * 0.7 && m < wheelTrough) wheelTrough = m;
          return wheelTrough !== Infinity && m >= 10 && m > wheelTrough * 2 + 4;
        };
        var armWheelGesture = function (dy, now) {
          wheelLocked = true;
          lastTrigger = now;
          wheelDir = dy > 0 ? 1 : -1;
          wheelPeak = Math.abs(dy);
          wheelTrough = Infinity;
          wheelOpposite = 0;
        };
        panelsWrap.addEventListener('wheel', function (e) {
          var now = performance.now();
          var gap = now - lastWheel;
          lastWheel = now;
          if (released) {
            if (e.deltaY < 0 && window.scrollY <= 0) {
              /* Arrivée en haut en remontant : reprise SANS changer de page.
                 La traîne du même geste est ignorée (verrou molette) ; c'est
                 le geste suivant qui remonte d'un panneau. */
              e.preventDefault();
              recapture();
              armWheelGesture(e.deltaY, now);
            }
            return;
          }
          e.preventDefault();
          var nouveau = isNewWheelGesture(e.deltaY, gap, now);
          if (wheelLocked && !nouveau) return;
          wheelLocked = false;
          if (Math.abs(e.deltaY) < 4) return;
          armWheelGesture(e.deltaY, now);
          if (e.deltaY > 0) {
            if (index === lastIndex) { release(); return; }
            go(index + 1);
          } else {
            go(index - 1);
          }
        }, { passive: false });

        /* Tactile : le panneau colle au doigt, la vitesse décide.
           Les gestes horizontaux amorcés dans un carrousel interne
           (tuiles) restent natifs. */
        var touchStartY = null;
        var touchStartX = null;
        var touchDelta = 0;
        var touchInHScroll = false;
        var touchAxis = null;
        var startOffset = 0;
        var baseIndex = 0;
        var lastY = 0;
        var lastT = 0;
        var velocity = 0; /* px/ms, négatif = vers le haut (page suivante) */
        panelsWrap.addEventListener('touchstart', function (e) {
          if (released && window.scrollY > 0) return;
          touchStartY = e.touches[0].clientY;
          touchStartX = e.touches[0].clientX;
          touchDelta = 0;
          touchAxis = null;
          velocity = 0;
          lastY = touchStartY;
          lastT = performance.now();
          touchInHScroll = !!e.target.closest('.hero-panel__tiles');
          if (!released) {
            /* Interrompre une transition en cours : on fige le panneau là
               où il est, et le doigt le reprend sans saut. */
            startOffset = readY();
            if (animating) {
              setY(startOffset, 0);
              animating = false;
              window.clearTimeout(animTimer);
            }
            baseIndex = Math.round(-startOffset / panelH());
          }
        }, { passive: true });

        panelsWrap.addEventListener('touchmove', function (e) {
          if (touchStartY === null) return;
          var y = e.touches[0].clientY;
          touchDelta = y - touchStartY;
          var deltaX = e.touches[0].clientX - touchStartX;
          if (touchAxis === null && (Math.abs(touchDelta) > 6 || Math.abs(deltaX) > 6)) {
            touchAxis = Math.abs(deltaX) > Math.abs(touchDelta) ? 'x' : 'y';
          }
          if (touchInHScroll && touchAxis === 'x') {
            /* swipe horizontal dans les tuiles : on laisse le scroll natif */
            touchStartY = null;
            return;
          }
          if (released) {
            /* Remontée tout en haut de page : le pager reprend la main sur
               le dernier panneau et le doigt continue de le tirer, sans
               saut (le geste devient un glisser de panneau ordinaire). */
            if (touchDelta > 0 && window.scrollY <= 0) {
              e.preventDefault();
              recapture();
              startOffset = -lastIndex * panelH();
              baseIndex = lastIndex;
              touchStartY = y;
              touchDelta = 0;
              lastY = y;
              lastT = performance.now();
              velocity = 0;
            }
            return;
          }
          e.preventDefault();
          var now = performance.now();
          var dt = now - lastT;
          if (dt > 0) velocity = 0.7 * ((y - lastY) / dt) + 0.3 * velocity;
          lastY = y;
          lastT = now;
          /* 1:1 avec le doigt ; résistance seulement aux deux bouts */
          var H = panelH();
          var target = startOffset + touchDelta;
          var min = -lastIndex * H;
          if (target > 0) target = target * 0.3;
          else if (target < min) target = min + (target - min) * 0.3;
          setY(target, 0);
        }, { passive: false });

        panelsWrap.addEventListener('touchend', function () {
          if (touchStartY === null) return;
          touchStartY = null;
          if (released) return;
          /* Un doigt resté immobile avant de se lever n'a plus d'élan */
          if (performance.now() - lastT > 90) velocity = 0;
          var H = panelH();
          var dest = baseIndex;
          if (touchDelta < -H * 0.18 || velocity < -0.35) dest = baseIndex + 1;
          else if (touchDelta > H * 0.18 || velocity > 0.35) dest = baseIndex - 1;
          if (dest > lastIndex) { go(lastIndex, Math.round(DURATION * 0.85)); release(); return; }
          dest = Math.max(0, dest);
          /* Continuité « Reels » : la durée est choisie pour que la page
             reparte à la vitesse du doigt (vitesse initiale de la courbe =
             pente × distance ÷ durée), puis freine. Bornée à 320–650 ms :
             jamais de saut, jamais de lenteur. Sans élan (doigt arrêté),
             durée normale. */
          var remaining = Math.abs(-dest * H - readY());
          var v = Math.abs(velocity);
          var ms = v > 0.05 ? (EASE_SLOPE * remaining) / v : DURATION;
          /* Vitesse maximale (V64) : un swipe très vif ne descend plus sous
             85 % de la durée réglée (470 ms à 550) ; plafond à 125 %. Tout
             découle du seul réglage « Vitesse de passage ». */
          ms = Math.round(Math.max(DURATION * 0.85, Math.min(DURATION * 1.25, ms)));
          go(dest, ms);
        });

        /* Clavier */
        document.addEventListener('keydown', function (e) {
          if (released) return;
          if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') {
            e.preventDefault();
            if (index === lastIndex) { release(); return; }
            go(index + 1);
          }
          if (e.key === 'ArrowUp' || e.key === 'PageUp') {
            e.preventDefault();
            go(index - 1);
          }
        });

        /* Rotation, clavier virtuel, barre d'adresse : la hauteur d'un
           panneau change, la position en pixels suit. */
        window.addEventListener('resize', function () {
          if (!released) setY(-index * panelH(), 0);
        }, { passive: true });

        /* État initial : le pager démarre TOUJOURS au premier panneau.
           Le navigateur restaure la position de scroll au rechargement ;
           sans ça, un simple F5 libérait le pager et sautait au dernier
           panneau (plus de logo géant, plus aucun changement de logo). */
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        window.scrollTo(0, 0);
        index = 0;
        setY(0, 0);
        lockBody();
        activatePanel(0);
        /* Sécurité : si le navigateur repositionne le scroll après coup */
        window.addEventListener('load', function () {
          if (!released) window.scrollTo(0, 0);
        });
      }
    }

    /* ---------- Carrousels horizontaux (flèches) ---------- */
    initCarousels(document);

    /* ---------- Galerie PDP : dots (vertical desktop / horizontal mobile) ---------- */
    var gallery = document.querySelector('.product-gallery');
    if (gallery && 'IntersectionObserver' in window) {
      var items = gallery.querySelectorAll('.product-gallery__item');
      var dots = gallery.querySelectorAll('.product-gallery__dot');
      var isMobile = window.matchMedia('(max-width: 989px)');

      function makeGalleryObserver() {
        var stack = gallery.querySelector('.product-gallery__stack');
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = Array.prototype.indexOf.call(items, entry.target);
              dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
            }
          });
        }, { root: isMobile.matches ? stack : null, threshold: 0.6 });
        items.forEach(function (i) { obs.observe(i); });
        return obs;
      }
      var galObserver = makeGalleryObserver();
      isMobile.addEventListener('change', function () {
        galObserver.disconnect();
        galObserver = makeGalleryObserver();
      });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          items[i].scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: isMobile.matches ? 'nearest' : 'center',
            inline: 'center'
          });
        });
      });
    }

    /* ---------- Galerie PDP, ordinateur : vignettes à gauche ---------- */
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    if (thumbs.length) {
      var gItems = document.querySelectorAll('.product-gallery__item');
      document.addEventListener('click', function (e) {
        var t = e.target.closest('.product-gallery__thumb');
        if (!t) return;
        var i = parseInt(t.getAttribute('data-thumb'), 10);
        thumbs.forEach(function (b, n) {
          b.classList.toggle('is-current', n === i);
          b.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
        gItems.forEach(function (it, n) { it.classList.toggle('is-current', n === i); });
      });
    }

    /* ---------- Panneaux latéraux de la fiche (liens soulignés) ---------- */
    var openPanel = null;
    function closeSidePanel() {
      if (!openPanel) return;
      openPanel.classList.remove('is-open');
      openPanel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (openPanel.__opener) openPanel.__opener.focus({ preventScroll: true });
      openPanel = null;
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-panel-open]');
      if (opener) {
        var panel = document.getElementById(opener.getAttribute('data-panel-open'));
        if (!panel) return;
        closeSidePanel();
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        panel.__opener = opener;
        document.body.style.overflow = 'hidden';
        openPanel = panel;
        var close = panel.querySelector('button[data-panel-close]');
        if (close) close.focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('[data-panel-close]')) closeSidePanel();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSidePanel();
    });

    /* ---------- ATC sticky mobile ---------- */
    var mainAtc = document.querySelector('[data-main-atc]');
    var stickyAtc = document.querySelector('.sticky-atc');
    if (mainAtc && stickyAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyAtc.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(mainAtc);
    }


    /* ---------- Page mot de passe : accès dissimulé ----------
       Aucun bouton visible. Le champ s'ouvre avec #acces dans l'adresse,
       après trois touchers rapides sur le titre, ou de lui-même après un
       mot de passe erroné. */
    var pwSecret = document.querySelector('[data-password-secret]');
    if (pwSecret) {
      var ouvrirAcces = function (focus) {
        pwSecret.hidden = false;
        var champ = pwSecret.querySelector('input[type="password"]');
        if (focus && champ) champ.focus();
      };
      if (/acces/i.test(window.location.hash) || document.querySelector('[data-password-error]')) {
        ouvrirAcces(false);
      }
      window.addEventListener('hashchange', function () {
        if (/acces/i.test(window.location.hash)) ouvrirAcces(true);
      });
      var tapCible = document.querySelector('[data-password-secret-tap]');
      if (tapCible) {
        var taps = 0, tapTimer = null;
        tapCible.addEventListener('click', function () {
          taps += 1;
          window.clearTimeout(tapTimer);
          tapTimer = window.setTimeout(function () { taps = 0; }, 700);
          if (taps >= 3) { taps = 0; ouvrirAcces(true); }
        });
      }
    }

    /* ---------- Menu : carrousel promo (points + légende) ---------- */
    var promo = document.querySelector('[data-menu-promo]');
    if (promo) {
      var pTrack = promo.querySelector('[data-menu-promo-track]');
      var pSlides = promo.querySelectorAll('.mega-menu__promo-slide');
      var pDots = promo.querySelectorAll('[data-menu-promo-dots] span');
      var pLabel = promo.querySelector('[data-menu-promo-label]');

      if (pTrack && pSlides.length > 1 && 'IntersectionObserver' in window) {
        var promoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var idx = Array.prototype.indexOf.call(pSlides, entry.target);
            pDots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
            var title = entry.target.getAttribute('data-title');
            if (pLabel && title) pLabel.textContent = title;
          });
        }, { root: pTrack, threshold: 0.6 });
        pSlides.forEach(function (sl) { promoObserver.observe(sl); });
      }
    }

    /* ---------- Hauteur d'écran réelle ----------
       Les unités vh/svh/dvh sont instables sur mobile quand le défilement
       est verrouillé (barre d'URL iOS) : le pied de page dépassait sous le
       dernier panneau. On mesure donc la hauteur visible et on la publie
       dans --vh-real, tenue à jour au redimensionnement et à la rotation. */
    function syncViewportHeight() {
      /* On retient la PLUS GRANDE mesure disponible. Un panneau trop haut
         est sans conséquence (le conteneur est en overflow:hidden), alors
         qu'un panneau trop court laisse apparaître le pied de page en bas
         d'écran — sans même avoir à faire défiler. visualViewport.height
         est plus petit que innerHeight sur iOS : le prendre seul créait
         précisément ce trou. */
      var candidates = [window.innerHeight || 0, document.documentElement.clientHeight || 0];
      if (window.visualViewport) candidates.push(window.visualViewport.height || 0);
      var h = Math.max.apply(null, candidates);
      if (h > 0) document.documentElement.style.setProperty('--vh-real', Math.round(h) + 'px');
    }
    syncViewportHeight();
    window.addEventListener('resize', syncViewportHeight, { passive: true });
    window.addEventListener('orientationchange', syncViewportHeight, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncViewportHeight, { passive: true });
    }

    /* ---------- Bandeau d'annonce : réserver sa hauteur ---------- */
    function syncAnnouncementHeight() {
      var bar = document.querySelector('.announcement');
      var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--announcement-h', h + 'px');
    }
    syncAnnouncementHeight();
    window.addEventListener('resize', syncAnnouncementHeight, { passive: true });
    document.addEventListener('shopify:section:load', syncAnnouncementHeight);
    document.addEventListener('shopify:section:unload', syncAnnouncementHeight);

    /* ---------- Bandeau d'annonce : rotation des messages ---------- */
    var ann = document.querySelector('[data-announcement]');
    if (ann) {
      var annItems = ann.querySelectorAll('.announcement__item');
      if (annItems.length > 1) {
        var annIdx = 0;
        var annDelay = (parseInt(ann.getAttribute('data-speed'), 10) || 5) * 1000;
        var annTimer = null;
        var showAnn = function (next) {
          ann.classList.add('is-rotating');
          ann.setAttribute('data-dir', next < annIdx ? 'prev' : 'next');
          annItems[annIdx].classList.remove('is-active');
          annIdx = (next + annItems.length) % annItems.length;
          annItems[annIdx].classList.add('is-active');
          syncAnnouncementHeight();
        };
        var startAnn = function () {
          if (reducedMotion) return;
          window.clearInterval(annTimer);
          annTimer = window.setInterval(function () { showAnn(annIdx + 1); }, annDelay);
        };
        /* Flèches : le message choisi reste affiché un tour complet. */
        document.addEventListener('click', function (e) {
          if (e.target.closest('[data-announcement-prev]')) { showAnn(annIdx - 1); startAnn(); }
          if (e.target.closest('[data-announcement-next]')) { showAnn(annIdx + 1); startAnn(); }
        });
        startAnn();
      }
    }

    /* ---------- Recommandations produits (API native Shopify) ---------- */
    var reco = document.querySelector('[data-recommendations]');
    if (reco && reco.dataset.url) {
      fetch(reco.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            reco.innerHTML = fresh.innerHTML;
            /* Contenu injecté : ré-appliquer l'état des cœurs et les animations */
            if (window.__paintWishlist) window.__paintWishlist();
            initReveals(reco);
            initCarousels(reco);
          }
        })
        .catch(function () { /* silencieux : la page reste utilisable */ });
    }

    /* ---------- Récemment consultés (localStorage, aucune donnée envoyée) ---------- */
    var RV_KEY = 'recently-viewed';
    function readRV() {
      try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
    }
    var rvMeta = document.querySelector('[data-product-handle]');
    if (rvMeta) {
      var handle = rvMeta.getAttribute('data-product-handle');
      var list = readRV().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
    }
    var rvBlock = document.querySelector('[data-recently-viewed]');
    if (rvBlock) {
      var rvTrack = rvBlock.querySelector('[data-recently-viewed-track]');
      var current = rvMeta ? rvMeta.getAttribute('data-product-handle') : null;
      var rvLimit = parseInt(rvBlock.getAttribute('data-limit'), 10) || 6;
      var handles = readRV().filter(function (h) { return h && h !== current; }).slice(0, rvLimit);
      if (handles.length) {
        Promise.all(handles.map(function (h) {
          return fetch('/products/' + h + '?view=card')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; });
        })).then(function (parts) {
          var html = parts.filter(Boolean).join('');
          if (html && rvTrack) {
            rvTrack.innerHTML = html;
            rvBlock.removeAttribute('hidden');
            if (window.__paintWishlist) window.__paintWishlist();
            initReveals(rvBlock);
          }
        });
      }
    }

    /* ---------- Recherche prédictive (API native Shopify) ---------- */
    var searchForm = document.querySelector('.mega-menu__search');
    if (searchForm) {
      var searchInput = searchForm.querySelector('input[name="q"]');
      var results = document.querySelector('[data-search-results]');
      var searchTimer = null;
      if (searchInput && results) {
        searchInput.addEventListener('input', function () {
          var q = searchInput.value.trim();
          window.clearTimeout(searchTimer);
          if (q.length < 2) { results.innerHTML = ''; results.hidden = true; return; }
          searchTimer = window.setTimeout(function () {
            fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search')
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var fresh = doc.querySelector('[data-search-results]');
                results.innerHTML = fresh ? fresh.innerHTML : '';
                results.hidden = !results.innerHTML.trim();
              })
              .catch(function () { results.hidden = true; });
          }, 250);
        });
      }
    }

    /* ---------- Pastilles de couleur nommées (fiche) ---------- */
    /* Un toucher sur une pastille affiche son nom à côté ; le même
       toucher le retire, une autre pastille le remplace. Délégué au
       document : les pastilles peuvent être réinjectées avec la fiche. */
    /* Fiche : la couleur s'affiche en entier (« Couleur : nom »). La
       première pastille nommée est choisie d'office ; un toucher change
       de couleur sans jamais tout désélectionner. */
    document.querySelectorAll('[data-product-color]').forEach(function (bloc) {
      var label = bloc.querySelector('[data-color-label]');
      var first = bloc.querySelector('.color-dots i[data-color-name]');
      if (first && label) {
        first.classList.add('is-selected');
        label.textContent = first.getAttribute('data-color-name');
      }
    });
    function basculerNomCouleur(dot) {
      var blocFiche = dot.closest('[data-product-color]');
      if (blocFiche) {
        blocFiche.querySelectorAll('.is-selected').forEach(function (d) { d.classList.remove('is-selected'); });
        dot.classList.add('is-selected');
        var lab = blocFiche.querySelector('[data-color-label]');
        if (lab) lab.textContent = dot.getAttribute('data-color-name');
        return;
      }
      var groupe = dot.closest('.color-dots');
      var sortie = groupe && groupe.querySelector('[data-color-name-out]');
      if (!sortie) return;
      var deja = dot.classList.contains('is-selected');
      groupe.querySelectorAll('.is-selected').forEach(function (d) { d.classList.remove('is-selected'); });
      if (deja) {
        /* Fermeture sans fondu : le nom est VIDÉ tout de suite, la
           pastille revient à sa place dans la même frame. Un fondu
           laissait le texte occuper sa largeur le temps de s'effacer,
           et la pastille restait décalée pendant ce délai. */
        sortie.classList.remove('is-visible');
        sortie.textContent = '';
        return;
      }
      dot.classList.add('is-selected');
      sortie.textContent = dot.getAttribute('data-color-name');
      sortie.classList.add('is-visible');
    }
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('.color-dots i[data-color-name]');
      /* Toucher le nom lui-même referme : on rebascule la pastille
         sélectionnée du même groupe. */
      if (!dot) {
        var nom = e.target.closest('.color-dots__name.is-visible');
        if (nom) dot = nom.closest('.color-dots').querySelector('i.is-selected');
      }
      if (!dot) return;
      e.preventDefault();
      basculerNomCouleur(dot);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var dot = e.target.closest && e.target.closest('.color-dots i[data-color-name]');
      if (!dot) return;
      e.preventDefault();
      basculerNomCouleur(dot);
    });

    /* ---------- Zoom image produit ---------- */
    var zoomLayer = null;
    document.addEventListener('click', function (e) {
      var img = e.target.closest('.product-gallery__item img');
      if (img && window.matchMedia('(min-width: 990px)').matches) {
        if (!zoomLayer) {
          zoomLayer = document.createElement('div');
          zoomLayer.className = 'image-zoom';
          var closeLabel = (window.strings && window.strings.closeZoom) || 'Fermer';
          zoomLayer.innerHTML =
            '<button type="button" class="image-zoom__close" aria-label="' + closeLabel + '">&times;</button><img alt="">';
          document.body.appendChild(zoomLayer);
          zoomLayer.addEventListener('click', function () { zoomLayer.classList.remove('is-open'); });
        }
        var zoomImg = zoomLayer.querySelector('img');
        zoomImg.src = img.currentSrc || img.src;
        zoomImg.alt = img.alt || ((window.strings && window.strings.zoom) || '');
        zoomLayer.classList.add('is-open');
      }
    });

    /* ---------- Guide des tailles : ouverture / fermeture ---------- */
    var sizeGuide = document.getElementById('SizeGuide');
    if (sizeGuide) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-size-guide-open]')) {
          sizeGuide.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        if (e.target.closest('[data-size-guide-close]')) {
          sizeGuide.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeGuide.classList.contains('is-open')) {
          sizeGuide.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }

    /* ---------- Wishlist (localStorage, aucune app, aucune donnée envoyée) ---------- */
    var WL_KEY = 'wishlist';
    function readWL() {
      try {
        var brut = JSON.parse(localStorage.getItem(WL_KEY) || '[]');
        if (!Array.isArray(brut)) return [];
        /* Une entrée vide ou non textuelle serait comptée sans jamais
           pouvoir être affichée : on ne la garde pas. */
        return brut.filter(function (h) { return typeof h === 'string' && h; });
      } catch (e) { return []; }
    }
    function writeWL(list) {
      try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
    }
    function paintWL() {
      var list = readWL();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var on = list.indexOf(btn.getAttribute('data-handle')) !== -1;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = list.length;
        el.classList.toggle('is-empty', list.length === 0);
      });
    }
    window.__paintWishlist = paintWL;
    paintWL();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      var list = readWL();
      var i = list.indexOf(handle);
      if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
      writeWL(list);
      paintWL();
      btn.classList.remove('is-bumping');
      void btn.offsetWidth;
      btn.classList.add('is-bumping');
    });

    /* Page wishlist : reconstruit les cartes depuis les identifiants gardés.

       Les identifiants qui ne répondent plus — pièce supprimée, renommée
       ou dépubliée — sont retirés de la sélection. Sans ce ménage, le
       cœur de l'en-tête continuait d'annoncer une pièce que la page ne
       pouvait pas afficher : compteur à 1, sélection vide à l'écran. */
    var wlGrid = document.querySelector('[data-wishlist-grid]');
    if (wlGrid) {
      var wlHandles = readWL();
      var wlEmpty = document.querySelector('[data-wishlist-empty]');
      if (!wlHandles.length) {
        if (wlEmpty) wlEmpty.hidden = false;
      } else {
        Promise.all(wlHandles.map(function (h) {
          return fetch('/products/' + h + '?view=card')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; })
            .then(function (html) { return { handle: h, html: html }; });
        })).then(function (parts) {
          var vivants = parts.filter(function (p) { return p.html; });

          if (vivants.length !== wlHandles.length) {
            writeWL(vivants.map(function (p) { return p.handle; }));
          }

          var html = vivants.map(function (p) { return p.html; }).join('');
          if (html) {
            wlGrid.innerHTML = html;
            if (wlEmpty) wlEmpty.hidden = true;
            initReveals(wlGrid);
          } else if (wlEmpty) {
            wlEmpty.hidden = false;
          }

          /* Repeint dans les deux cas : quand tout a disparu, c'est
             justement là que le compteur doit retomber à zéro. */
          paintWL();
        });
      }
    }

    /* ---------- Navigation plus fluide : préchargement au survol ----------
       Au survol (ou au premier contact tactile) d'un lien interne, la page
       est préchargée. Le clic devient quasi instantané, sans framework. */
    (function () {
      var prefetched = {};
      function prefetch(url) {
        if (!url || prefetched[url]) return;
        prefetched[url] = true;
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url;
        document.head.appendChild(link);
      }
      function candidate(e) {
        var a = e.target.closest('a');
        if (!a || !a.href) return;
        if (a.target === '_blank' || a.hasAttribute('download')) return;
        if (a.origin !== window.location.origin) return;
        if (a.pathname === window.location.pathname) return;
        if (/\/(cart|checkout|account)/.test(a.pathname)) return;
        prefetch(a.href);
      }
      document.addEventListener('mouseover', candidate, { passive: true });
      document.addEventListener('touchstart', candidate, { passive: true });
    })();

    /* ---------- Barre de livraison offerte ---------- */
    function paintShipBars(total) {
      document.querySelectorAll('[data-ship-bar]').forEach(function (bar) {
        var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
        var current = typeof total === 'number' ? total : (parseInt(bar.getAttribute('data-total'), 10) || 0);
        bar.setAttribute('data-total', current);
        var pct = threshold > 0 ? Math.min(100, Math.round((current / threshold) * 100)) : 100;
        var fill = bar.querySelector('[data-ship-bar-fill]');
        if (fill) fill.style.transform = 'scaleX(' + (pct / 100) + ')';
        bar.classList.toggle('is-done', current >= threshold);
      });
    }
    paintShipBars();

    /* ---------- Paliers de quantité ---------- */
    document.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-tier-qty]');
      if (!radio) return;
      var scope = radio.closest('.tiers');
      var input = scope && scope.querySelector('[data-tier-input]');
      if (input) input.value = radio.value;
    });

    /* ---------- Option cadeau : dépliage + compteur de caractères ---------- */
    var giftBox = document.querySelector('[data-gift-options]');
    if (giftBox) {
      var giftToggle = giftBox.querySelector('[data-gift-toggle]');
      var giftNote = giftBox.querySelector('[data-gift-note]');
      var giftCount = giftBox.querySelector('[data-gift-count]');

      var giftForm = giftBox.querySelector('form');
      var giftSave = giftBox.querySelector('[data-gift-save]');
      var giftStatus = giftBox.querySelector('[data-gift-status]');

      /* Enregistrement EN DIRECT, sans rechargement : un envoi classique
         rechargeait la page et réaffichait les mêmes valeurs — rien ne
         disait que c'était enregistré. Ici : bouton « ✓ Enregistré »,
         ligne de confirmation, et l'état se réarme dès qu'un champ
         change. Les attributs sont lus du formulaire lui-même (champ
         caché vide + case cochée : la dernière valeur l'emporte), donc
         une case décochée envoie bien une valeur vide. En cas d'échec
         réseau, on laisse le formulaire partir normalement. */
      var attributsDuFormulaire = function () {
        var fd = new FormData(giftForm);
        var attrs = {};
        fd.forEach(function (valeur, cle) {
          var m = cle.match(/^attributes\[(.+)\]$/);
          if (m) attrs[m[1]] = valeur;
        });
        return attrs;
      };
      var envoyerAttributs = function (attrs) {
        return fetch(window.routes.cart_update_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
      };
      var montrerStatut = function (texte, retire) {
        if (!giftStatus) return;
        giftStatus.textContent = texte;
        giftStatus.classList.toggle('is-removed', !!retire);
        giftStatus.classList.add('is-visible');
      };
      var rearmer = function () {
        if (giftStatus) giftStatus.classList.remove('is-visible');
        if (giftSave) {
          giftSave.classList.remove('is-done');
          giftSave.textContent = giftSave.getAttribute('data-label-save');
        }
      };

      if (giftForm && giftSave && window.fetch) {
        giftForm.addEventListener('submit', function (e) {
          e.preventDefault();
          giftSave.classList.add('is-loading');
          giftSave.disabled = true;
          envoyerAttributs(attributsDuFormulaire()).then(function () {
            giftSave.classList.remove('is-loading');
            giftSave.disabled = false;
            giftSave.classList.add('is-done');
            giftSave.textContent = giftSave.getAttribute('data-label-saved');
            montrerStatut(giftStatus.getAttribute('data-text-saved'), false);
          }).catch(function () {
            giftSave.classList.remove('is-loading');
            giftSave.disabled = false;
            giftForm.submit();
          });
        });
        giftForm.addEventListener('input', function (e) {
          if (e.target !== giftToggle) rearmer();
        });
      }

      if (giftToggle) {
        giftToggle.addEventListener('change', function () {
          /* Le panneau se déplie, mais on ne prend PAS le focus : un
             focus() programmé fait surgir le clavier virtuel par-dessus
             le récapitulatif. Le clavier ne doit sortir que si la
             personne touche elle-même un champ. */
          giftBox.classList.toggle('is-open', giftToggle.checked);
          if (giftToggle.checked) { rearmer(); return; }
          /* Décochée : on retire l'option TOUT DE SUITE. Le bouton vit
             dans le panneau qui vient de se replier — sans cet envoi,
             « Offrir : Oui » restait attaché à la commande. */
          if (!window.fetch) return;
          var vide = {};
          Object.keys(attributsDuFormulaire()).forEach(function (k) { vide[k] = ''; });
          envoyerAttributs(vide).then(function () {
            rearmer();
            var hors = giftBox.querySelector('[data-gift-status-outside]');
            if (!hors) {
              hors = document.createElement('p');
              hors.className = 'gift-options__status gift-options__status--outside';
              hors.setAttribute('data-gift-status-outside', '');
              hors.setAttribute('role', 'status');
              giftForm.appendChild(hors);
            }
            hors.textContent = giftStatus ? giftStatus.getAttribute('data-text-removed') : '';
            hors.classList.add('is-removed', 'is-visible');
            window.clearTimeout(hors._timer);
            hors._timer = window.setTimeout(function () { hors.classList.remove('is-visible'); }, 3000);
          }).catch(function () {});
        });
      }
      if (giftNote && giftCount) {
        var updateCount = function () { giftCount.textContent = giftNote.value.length; };
        giftNote.addEventListener('input', updateCount);
        updateCount();
      }
    }

    /* ---------- Disponibilité des options selon la sélection ----------
       Une valeur reste barrée tant qu'aucune variante disponible ne
       combine cette valeur avec les autres options déjà choisies. */
    function refreshOptionAvailability(variants) {
      var groups = document.querySelectorAll('[data-option-index]');
      if (!groups.length || !variants.length) return;

      var selected = [];
      groups.forEach(function (g) {
        var checked = g.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });

      groups.forEach(function (group, gi) {
        group.querySelectorAll('input[data-option-input]').forEach(function (input) {
          var possible = variants.some(function (variant) {
            if (!variant.available) return false;
            if (variant.options[gi] !== input.value) return false;
            return variant.options.every(function (opt, oi) {
              return oi === gi || selected[oi] === null || selected[oi] === opt;
            });
          });
          var label = input.closest('.option-pill, .swatch');
          if (label) label.classList.toggle('is-unavailable', !possible);
          input.toggleAttribute('data-unavailable', !possible);
        });
      });
    }

    /* ---------- Partage produit ---------- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share]');
      if (!btn) return;
      var url = btn.getAttribute('data-share-url');
      var title = btn.getAttribute('data-share-title');
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      /* Sans partage natif (ordinateur) : on copie le lien et on le dit. */
      var done = function () {
        var original = btn.querySelector('span').textContent;
        btn.querySelector('span').textContent = btn.getAttribute('data-copied-label');
        btn.classList.add('is-done');
        window.setTimeout(function () {
          btn.querySelector('span').textContent = original;
          btn.classList.remove('is-done');
        }, 2000);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      }
    });

    /* ---------- Retour en haut de page ---------- */
    var toTop = document.querySelector('[data-to-top]');
    if (toTop) {
      var toggleToTop = function () {
        toTop.classList.toggle('is-visible', window.scrollY > window.innerHeight);
      };
      window.addEventListener('scroll', toggleToTop, { passive: true });
      toggleToTop();
      toTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    }

    /* ---------- Fenêtre e-mails ----------
       Garde-fous : jamais pendant le tunnel d'achat, jamais deux fois
       dans la même visite, plus jamais après inscription, et respect du
       délai de rappel choisi. */
    var popup = document.querySelector('[data-popup]');
    if (popup) {
      var POPUP_KEY = 'popup-newsletter';
      var path = window.location.pathname;
      var inCheckout = /\/(cart|checkout)/.test(path);

      var readPopupState = function () {
        try { return JSON.parse(localStorage.getItem(POPUP_KEY) || '{}'); }
        catch (e) { return {}; }
      };
      var state = readPopupState();
      var now = Date.now();
      var days = parseInt(popup.getAttribute('data-days'), 10) || 14;

      /* Mode test : actif seulement dans l'éditeur de thème. En boutique il
         est sans effet — impossible d'imposer la fenêtre à une cliente. */
      var testMode = popup.getAttribute('data-test') === '1'
        && !!(window.Shopify && window.Shopify.designMode);
      if (testMode) inCheckout = false;

      var alreadySubscribed = !testMode && state.subscribed === true;
      var stillSnoozed = !testMode && state.dismissedAt && (now - state.dismissedAt) < days * 86400000;
      var seenThisVisit = !testMode && sessionStorage.getItem(POPUP_KEY) === 'seen';

      var lastFocus = null;
      var closePopup = function () {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (!testMode) {
          try {
            var prev = readPopupState();
            prev.dismissedAt = Date.now();
            localStorage.setItem(POPUP_KEY, JSON.stringify(prev));
          } catch (e) {}
        }
        if (lastFocus) lastFocus.focus();
      };

      /* Fermeture toujours active : croix, fond, « Non merci » et touche Échap,
         quel que soit l'état d'ouverture (y compris l'écran « Merci »). */
      popup.addEventListener('click', function (e) {
        if (e.target.closest('[data-popup-close]')) closePopup();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
      });

      var openPopup = function () {
        if (popup.classList.contains('is-open')) return;
        lastFocus = document.activeElement;
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (!testMode) {
          try { sessionStorage.setItem(POPUP_KEY, 'seen'); } catch (e) {}
        }
        var field = popup.querySelector('input[type="email"]');
        if (field) field.focus();
      };

      /* Éditeur : sélectionner la section l'ouvre, la quitter la referme. */
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(popup)) openPopup();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(popup)) closePopup();
      });

      /* Une inscription réussie recharge la page : on mémorise et on sort. */
      if (popup.querySelector('[data-popup-success]')) {
        try { localStorage.setItem(POPUP_KEY, JSON.stringify({ subscribed: true })); } catch (e) {}
        popup.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      } else if (!inCheckout && !alreadySubscribed && !stillSnoozed && !seenThisVisit) {
        var trigger = popup.getAttribute('data-trigger');
        if (testMode) {
          /* Pas d'attente : on veut la voir dès qu'on ouvre la section. */
          openPopup();
        } else if (trigger === 'scroll') {
          var pct = parseInt(popup.getAttribute('data-scroll'), 10) || 40;
          var onScroll = function () {
            var h = document.documentElement.scrollHeight - window.innerHeight;
            if (h > 0 && (window.scrollY / h) * 100 >= pct) {
              openPopup();
              window.removeEventListener('scroll', onScroll);
            }
          };
          window.addEventListener('scroll', onScroll, { passive: true });
        } else if (trigger === 'exit') {
          /* Départ de page : seulement sur ordinateur, le geste n'existe
             pas au doigt. Un délai long sert de repli sur mobile. */
          if (window.matchMedia('(min-width: 990px)').matches) {
            document.addEventListener('mouseout', function onExit(e) {
              if (!e.relatedTarget && e.clientY <= 0) {
                openPopup();
                document.removeEventListener('mouseout', onExit);
              }
            });
          } else {
            window.setTimeout(openPopup, 45000);
          }
        } else {
          var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 20) * 1000;
          window.setTimeout(openPopup, delay);
        }
      }
    }

    /* ---------- Onglets : images intercalées ----------
       Le panneau est réinjecté à chaque changement d'onglet : les images
       doivent donc être reposées après chaque rendu, sans quoi elles
       disparaîtraient au premier clic. Elles sont clonées depuis une
       réserve tenue hors du panneau, qu'aucun re-rendu n'atteint. */
    function poserImagesOnglet(root, rangOnglet) {
      var panel = root.querySelector('[data-tab-panel]');
      var reserve = root.querySelector('[data-tabs-media]');
      if (!panel || !reserve) return;

      panel.querySelectorAll('[data-tabs-media-item]').forEach(function (n) {
        n.parentNode.removeChild(n);
      });

      var items = Array.prototype.slice.call(reserve.querySelectorAll('[data-tabs-media-item]'));
      if (!items.length) return;

      /* Du rang le plus élevé au plus bas : insérer par la fin laisse les
         rangs suivants intacts, alors qu'insérer par le début les décale. */
      items.sort(function (a, b) {
        return (parseInt(b.getAttribute('data-position'), 10) || 1)
             - (parseInt(a.getAttribute('data-position'), 10) || 1);
      });

      items.forEach(function (item) {
        /* « data-onglet » et non « data-tab » : ce dernier désigne les
           boutons d'onglet, et le script y attachait par erreur les
           images intercalées — comptées comme des onglets, cliquables. */
        var seulement = parseInt(item.getAttribute('data-onglet'), 10) || 0;
        if (seulement && seulement !== rangOnglet) return;
        var rang = parseInt(item.getAttribute('data-position'), 10) || 1;
        var cartes = panel.querySelectorAll('.card-product');
        var clone = item.cloneNode(true);
        if (cartes[rang - 1]) {
          panel.insertBefore(clone, cartes[rang - 1]);
        } else {
          panel.appendChild(clone);
        }
      });

      /* Un seul produit face à une image : ils se partagent la largeur.
         Le comptage se fait ici, après le placement, car le nombre de
         produits d'un onglet n'est connu qu'une fois sa grille rendue. */
      var duo = root.getAttribute('data-solo-split') !== 'false'
        && panel.querySelectorAll('.card-product').length === 1
        && panel.querySelectorAll('[data-tabs-media-item]').length > 0;
      panel.classList.toggle('is-solo', duo);
    }

    /* ---------- Onglets de collections (sans rechargement) ---------- */
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
      var panel = root.querySelector('[data-tab-panel]');
      var moreLink = root.querySelector('[data-tab-link]');
      var limit = root.getAttribute('data-limit') || 8;
      if (!tabs.length || !panel) return;

      var cache = {};

      var select = function (tab) {
        if (tab.classList.contains('is-active')) return;

        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        if (moreLink) moreLink.href = tab.getAttribute('data-url') || '#';

        var handle = tab.getAttribute('data-handle');
        if (!handle) return;

        /* Contenu déjà chargé : on le remet sans nouvel appel réseau. */
        if (cache[handle]) {
          panel.innerHTML = cache[handle];
          poserImagesOnglet(root, tabs.indexOf(tab) + 1);
          initReveals(panel);
          if (window.__paintWishlist) window.__paintWishlist();
          return;
        }

        panel.setAttribute('aria-busy', 'true');
        root.classList.add('is-loading');

        fetch('/collections/' + handle + '?view=grid&limit=' + limit)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html.trim()) return;
            cache[handle] = html;
            panel.innerHTML = html;
            poserImagesOnglet(root, tabs.indexOf(tab) + 1);
            initReveals(panel);
            if (window.__paintWishlist) window.__paintWishlist();
          })
          .catch(function () { /* la grille précédente reste affichée */ })
          .finally(function () {
            panel.setAttribute('aria-busy', 'false');
            root.classList.remove('is-loading');
          });
      };

      /* Premier onglet : le serveur a déjà posé les images, on les repose
         par le même chemin pour que l'état de départ et les suivants
         soient produits par un seul et même code. */
      poserImagesOnglet(root, 1);

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { select(tab); });
      });

      /* Navigation au clavier entre onglets, comme attendu d'un onglet. */
      root.querySelector('[role="tablist"]').addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i === -1) return;
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        e.preventDefault();
        next.focus();
        select(next);
      });
    });

    /* ---------- Shop the look : panneau des pièces ----------
       Ouverture et fermeture passent par ces deux fonctions, partagées
       par le clic et le survol : une seule logique, donc pas de risque
       que les deux chemins divergent. */
    function fermerLooks(sauf) {
      document.querySelectorAll('.stl__look').forEach(function (l) {
        if (l !== sauf) l.setAttribute('hidden', '');
      });
      document.querySelectorAll('.stl__slide').forEach(function (sl) {
        if (!sauf || !sl.contains(sauf)) sl.classList.remove('is-look-open');
      });
      document.querySelectorAll('[data-look-open]').forEach(function (b) {
        if (!sauf || b.getAttribute('data-look-open') !== sauf.id) {
          b.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function ouvrirLook(panel) {
      if (!panel) return;
      fermerLooks(panel); /* un seul panneau ouvert à la fois */
      panel.removeAttribute('hidden');
      var opener = document.querySelector('[data-look-open="' + panel.id + '"]');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      /* Floute l'image de la carte pendant l'ouverture */
      var slide = panel.closest('.stl__slide');
      if (slide) slide.classList.add('is-look-open');
    }

    function fermerLook(panel) {
      if (!panel || panel.hasAttribute('hidden')) return;
      panel.setAttribute('hidden', '');
      var host = panel.closest('.stl__slide');
      if (host) host.classList.remove('is-look-open');
      var btn = document.querySelector('[data-look-open="' + panel.id + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    /* Le survol est-il actif pour ce carrousel ? */
    function survolAutorise(slide) {
      var root = slide.closest('.stl');
      return !root || root.getAttribute('data-look-hover') !== 'false';
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var opener = e.target.closest('[data-look-open]');
      if (opener) {
        var target = document.getElementById(opener.getAttribute('data-look-open'));
        if (!target) return;
        if (target.hasAttribute('hidden')) { ouvrirLook(target); } else { fermerLooks(null); }
      }
      if (e.target.closest('[data-look-close]')) {
        var panel = e.target.closest('.stl__look');
        if (panel) {
          var btn = document.querySelector('[data-look-open="' + panel.id + '"]');
          fermerLook(panel);
          if (btn) btn.focus();
        }
      }
    });

    /* ---------- Shop the look : ouverture au survol (ordinateur) ----------
       Réservé aux pointeurs fins. Au doigt, « survoler » n'existe pas :
       le premier contact ouvrirait le panneau sans qu'on l'ait demandé,
       et le clic resterait le seul geste possible pour le refermer.
       Le panneau étant borné à la carte (inset: 0), la sortie de la carte
       est la bonne frontière — passer du bouton au panneau ne la franchit
       jamais, donc aucun scintillement. */
    var pointeurFin = window.matchMedia('(hover: hover) and (pointer: fine)');

    document.addEventListener('mouseover', function (e) {
      if (!pointeurFin.matches || !e.target.closest) return;
      var slide = e.target.closest('.stl__slide');
      if (!slide || !survolAutorise(slide)) return;
      var panel = slide.querySelector('.stl__look');
      if (panel && panel.hasAttribute('hidden')) ouvrirLook(panel);
    });

    document.addEventListener('mouseout', function (e) {
      if (!pointeurFin.matches || !e.target.closest) return;
      var slide = e.target.closest('.stl__slide');
      if (!slide || !survolAutorise(slide)) return;
      /* On ne ferme que si le pointeur quitte réellement la carte */
      if (e.relatedTarget && slide.contains(e.relatedTarget)) return;
      fermerLook(slide.querySelector('.stl__look'));
    });

    /* ---------- Achat rapide (Shop the look) ----------
       Chaque formulaire est autonome : ses propres variantes, ses propres
       sélecteurs. Le choix recalcule la variante et met à jour le prix. */
    document.querySelectorAll('[data-quickshop]').forEach(function (form) {
      var json = form.querySelector('[data-qs-variants]');
      var idField = form.querySelector('[data-qs-id]');
      var priceEl = form.querySelector('[data-qs-price]');
      var submit = form.querySelector('.quickshop__add');
      if (!json || !idField) return;

      var variants = [];
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }

      /* Prix déjà formatés par Shopify, indexés par identifiant de variante */
      var priceMap = {};
      var priceJson = form.querySelector('[data-qs-prices]');
      if (priceJson) {
        try { priceMap = JSON.parse(priceJson.textContent); } catch (e) { priceMap = {}; }
      }

      function refresh() {
        var chosen = [];
        form.querySelectorAll('[data-qs-option-group]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          chosen.push(checked ? checked.value : null);
        });

        /* Aucune option : produit à variante unique */
        var match = chosen.length
          ? variants.find(function (v) {
              return v.options.every(function (o, i) { return o === chosen[i]; });
            })
          : variants[0];

        form.querySelectorAll('.quickshop__pill').forEach(function (pill) {
          var input = pill.querySelector('input');
          pill.classList.toggle('is-selected', !!(input && input.checked));
        });

        if (match) {
          idField.value = match.id;
          if (priceEl && priceMap[match.id]) priceEl.innerHTML = priceMap[match.id];
          if (submit) {
            submit.disabled = !match.available;
            submit.textContent = match.available
              ? (submit.getAttribute('data-label-add') || submit.textContent)
              : (submit.getAttribute('data-label-sold') || submit.textContent);
          }
        } else if (submit) {
          submit.disabled = true;
        }
      }

      /* Mémoriser les libellés avant toute modification */
      if (submit) {
        submit.setAttribute('data-label-add', submit.textContent.trim());
        submit.setAttribute('data-label-sold', submit.getAttribute('data-label-sold') || submit.textContent.trim());
      }

      form.querySelectorAll('[data-qs-input]').forEach(function (input) {
        input.addEventListener('change', refresh);
      });
    });

    /* ---------- Galerie des cartes produit ----------
       Les points ne suivaient rien : deux pastilles figées étaient
       dessinées quoi qu'il arrive. Ils reflètent désormais la photo
       réellement affichée quand la piste est balayée au doigt. */
    document.querySelectorAll('[data-card-track]').forEach(function (piste) {
      var points = piste.parentNode.querySelector('[data-card-dots]');
      if (!points) return;
      var pastilles = points.children;
      var enAttente = false;

      /* Filet de sécurité du magnétisme : quand le doigt part en
         diagonale, la page défile en même temps et le navigateur laisse
         parfois la piste entre deux photos. À la fin du geste
         (`scrollend`, sinon 150 ms après le dernier événement), si la
         piste n'est pas alignée, on la recale sur la photo la plus
         proche. */
      var recalage = null;
      var recaler = function () {
        var largeur = piste.clientWidth;
        if (!largeur) return;
        var cible = Math.round(piste.scrollLeft / largeur) * largeur;
        if (Math.abs(piste.scrollLeft - cible) > 1) {
          piste.scrollTo({ left: cible, behavior: reducedMotion ? 'auto' : 'smooth' });
        }
      };
      if ('onscrollend' in window) {
        piste.addEventListener('scrollend', recaler, { passive: true });
      } else {
        piste.addEventListener('scroll', function () {
          window.clearTimeout(recalage);
          recalage = window.setTimeout(recaler, 150);
        }, { passive: true });
      }

      piste.addEventListener('scroll', function () {
        /* Un défilement émet des dizaines d'événements : on ne recalcule
           qu'une fois par image rendue. */
        if (enAttente) return;
        enAttente = true;
        window.requestAnimationFrame(function () {
          enAttente = false;
          var largeur = piste.clientWidth;
          if (!largeur) return;
          var index = Math.round(piste.scrollLeft / largeur);
          for (var i = 0; i < pastilles.length; i++) {
            pastilles[i].classList.toggle('is-active', i === index);
          }
        });
      }, { passive: true });
    });

    /* ---------- Cadeau de palier devenu orphelin ----------
       Quand la cliente retire les articles qui lui avaient ouvert le
       palier, le cadeau restait au panier : elle repartait avec un
       cadeau sans l'achat qui le justifiait.

       Le seuil est recalculé en Liquid à chaque rendu, cadeau exclu du
       total ; le gabarit désigne la ligne à retirer et le script se
       contente de l'exécuter. Aucun calcul de seuil côté JS, donc aucune
       divergence possible avec l'affichage. */
    var CLE_NETTOYAGE = 'avelyn:nettoyage-cadeau';

    function lireEssais() {
      try { return parseInt(window.sessionStorage.getItem(CLE_NETTOYAGE), 10) || 0; }
      catch (e) { return 0; }
    }
    function ecrireEssais(n) {
      try {
        if (n) { window.sessionStorage.setItem(CLE_NETTOYAGE, n); }
        else { window.sessionStorage.removeItem(CLE_NETTOYAGE); }
      } catch (e) { /* navigation privée : on s'en passe */ }
    }

    function retirerCadeauOrphelin() {
      var marqueur = document.querySelector('[data-gift-orphan]');
      if (!marqueur) return;
      var cle = marqueur.getAttribute('data-gift-orphan');
      if (!cle) { ecrireEssais(0); return; }

      /* Garde-fou. Sur la page panier le retrait se termine par un
         rechargement, qui remet à zéro toute variable de page : le
         compteur vit donc dans la session. Sans lui, un retrait qui
         échouerait sans le dire — `fetch` ne rejette pas sur une réponse
         d'erreur — relancerait le rechargement indéfiniment. */
      var essais = lireEssais();
      if (essais >= 3) return;
      ecrireEssais(essais + 1);

      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cle, quantity: 0 })
      }).then(function (r) {
        if (!r.ok) return; /* échec : le panier reste tel quel */
        if (document.querySelector('.cart-page')) {
          window.location.reload();
        } else {
          refreshDrawer(false);
        }
      }).catch(function () { /* hors ligne : on ne touche à rien */ });
    }

    /* ---------- Panier : AJAX + drawer ---------- */
    /* La barre de paliers est rendue par le serveur et remplacée d'un bloc
       (innerHTML) : la barre neuve naît déjà à sa largeur finale, aucune
       transition CSS ne peut jouer. On lit donc le pourcentage de la barre
       qu'on va jeter, on le pose sur la neuve, on force un calcul de style,
       puis on la laisse rejoindre sa vraie valeur — le remplissage glisse
       au lieu de sauter. */
    function lirePourcentBarre(racine) {
      var fill = racine && racine.querySelector('.cart-rewards__fill');
      return fill ? fill.style.getPropertyValue('--rw-percent') : '';
    }
    function animerBarre(racine, ancienPourcent) {
      if (ancienPourcent === '' || reducedMotion) return;
      var fill = racine && racine.querySelector('.cart-rewards__fill');
      if (!fill) return;
      var cible = fill.style.getPropertyValue('--rw-percent');
      if (cible === ancienPourcent) return;
      fill.style.setProperty('--rw-percent', ancienPourcent);
      void fill.offsetWidth;
      fill.style.setProperty('--rw-percent', cible);
    }
    /* Applique un rendu du tiroir déjà obtenu. Séparé de la requête pour
       que l'ajout au panier puisse fournir ce rendu lui-même : Shopify le
       renvoie dans la réponse de /cart/add.js quand on le lui demande, ce
       qui épargne un aller-retour serveur complet à chaque ajout. */
    function appliquerTiroir(html, openAfter) {
      return Promise.resolve(html).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#CartDrawer');
          var current = document.querySelector('#CartDrawer');
          if (fresh && current) {
            var ancienPourcent = lirePourcentBarre(current);
            current.innerHTML = fresh.innerHTML;
            animerBarre(current, ancienPourcent);
            if (openAfter) {
              /* Le panneau vient d'être injecté : il n'a jamais été peint en
                 position fermée. Poser la classe dans la même frame ferait
                 sauter la transition. On force un calcul de style, puis on
                 ouvre à la frame suivante — le glissement est alors visible. */
              var panel = current.querySelector('.cart-drawer__panel');
              if (panel) void panel.offsetWidth;
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  current.classList.add('is-open');
                  hideToast();
                });
              });
            }
            if (window.__paintWishlist) window.__paintWishlist();
          }
          /* La pastille et le compteur vivent dans l'en-tête, pas dans le
             fragment du tiroir : les y chercher ne renvoyait jamais rien et
             le compteur restait figé sur la valeur du chargement de page.
             La racine du tiroir porte désormais le compte, calculé en
             Liquid — donc toujours celui du serveur. */
          var freshCount = fresh ? fresh.getAttribute('data-cart-item-count') : null;
          if (freshCount !== null) {
            var estVide = freshCount.trim() === '0';
            document.querySelectorAll('[data-cart-bubble]').forEach(function (b) {
              b.textContent = freshCount;
              b.classList.toggle('is-empty', estVide);
            });
            document.querySelectorAll('[data-cart-count]').forEach(function (c) {
              c.textContent = freshCount;
            });
          }
          var freshBar = doc.querySelector('[data-ship-bar]');
          if (freshBar) paintShipBars(parseInt(freshBar.getAttribute('data-total'), 10));
          poserBarrePaliers();
          retirerCadeauOrphelin();
        });
    }

    function refreshDrawer(openAfter) {
      return fetch(window.routes.cart_url + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) { return appliquerTiroir(html, openAfter); });
    }

    /* Petit message de confirmation, créé une seule fois */
    function showToast(message) {
      var toast = document.querySelector('.toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._timer);
      toast._timer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2600);
    }

    /* Le tiroir est une confirmation plus complète que le message, et il
       se glisse par-dessus : le message venait recouvrir les boutons de
       paiement posés en bas du panneau. À l'ouverture, on le retire. */
    function hideToast() {
      var toast = document.querySelector('.toast');
      if (!toast) return;
      window.clearTimeout(toast._timer);
      toast.classList.remove('is-visible');
    }

    /* Anime la pastille du panier et met le compteur à jour */
    function pulseCart(count) {
      document.querySelectorAll('[data-cart-bubble]').forEach(function (bubble) {
        /* Sans argument, on se contente d'animer : « !undefined » valant
           vrai, l'ancien code remettait « is-empty » juste après que le
           re-rendu du tiroir eut posé le bon compte — la pastille
           retombait donc à zéro et disparaissait. */
        if (typeof count === 'number') {
          bubble.textContent = count;
          bubble.classList.toggle('is-empty', !count);
        }
        bubble.classList.remove('is-pulsing');
        void bubble.offsetWidth; /* relance l'animation */
        bubble.classList.add('is-pulsing');
      });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';

      if (btn) {
        btn.disabled = true;
        btn.classList.add('is-loading');
      }

      /* « sections » : Shopify renvoie le tiroir déjà rendu avec la
         confirmation d'ajout. Un seul aller-retour au lieu de deux en
         série — c'était la moitié du temps d'attente entre le clic et
         l'ouverture. */
      var donnees = new FormData(form);
      donnees.append('sections', 'cart-drawer');
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: donnees
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) {
              /* Shopify renvoie le motif exact (stock insuffisant, variante
                 indisponible…). L'afficher vaut mieux qu'une redirection
                 silencieuse qui fait perdre sa page à la cliente. */
              var err = new Error(data.description || data.message || 'error');
              err.handled = true;
              throw err;
            }
            return data;
          });
        })
        .then(function (item) {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-done');
            btn.textContent = btn.getAttribute('data-added-label') || 'Ajouté';
          }
          showToast((item && item.product_title ? item.product_title : '') + ' — ' + (btn && btn.getAttribute('data-added-label') || 'ajouté au panier'));
          var rendu = item && item.sections && item.sections['cart-drawer'];
          var maj = rendu ? appliquerTiroir(rendu, false) : refreshDrawer(false);
          return maj.then(function () {
            pulseCart();
            /* Le tiroir s'ouvre après le retour visuel du bouton — 300 ms
               suffisent à lire « Ajouté », 450 se ressentaient comme une
               attente. */
            window.setTimeout(function () {
              var d = document.getElementById('CartDrawer');
              if (d) {
                d.classList.add('is-open');
                hideToast();
              }
            }, 300);
          });
        })
        .catch(function (err) {
          if (err && err.handled) {
            showToast(err.message);
            if (btn) btn.classList.remove('is-loading');
          } else {
            window.location.href = window.routes.cart_url;
          }
        })
        .finally(function () {
          window.setTimeout(function () {
            if (!btn) return;
            btn.disabled = false;
            btn.classList.remove('is-loading', 'is-done');
            btn.textContent = label;
          }, 1800);
        });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) {
        e.preventDefault();
        /* Ouverture immédiate : le tiroir est rendu par le serveur dans
           chaque page, son contenu est déjà juste. Attendre le
           rafraîchissement avant d'ouvrir laissait le clic sans effet
           pendant tout l'aller-retour (200 ms mesurés en bonne
           connexion, bien plus sur mobile). Le rafraîchissement part
           quand même, en arrière-plan : il couvre un panier modifié
           depuis un autre onglet, et remplace le contenu sans fermer. */
        var tiroir = document.getElementById('CartDrawer');
        if (tiroir) {
          tiroir.classList.add('is-open');
          hideToast();
        }
        refreshDrawer(false);
      }
      if (e.target.closest('[data-cart-close]') || e.target.classList.contains('cart-drawer__backdrop')) {
        var d = document.getElementById('CartDrawer');
        if (d) d.classList.remove('is-open');
      }
      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        var line = qtyBtn.getAttribute('data-line');
        var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        /* La ligne passe en attente : sans retour visuel, le clic semble
           sans effet le temps de l'aller-retour serveur. */
        var lineEl = qtyBtn.closest('.cart-line, .cart-row');
        if (lineEl) lineEl.classList.add('is-busy');
        fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          /* Le tiroir rendu est demandé dans la même réponse : un
             aller-retour au lieu de deux. */
          body: JSON.stringify({ line: parseInt(line, 10), quantity: qty, sections: 'cart-drawer' })
        }).then(function (r) { return r.json(); }).then(function (data) {
          if (document.querySelector('.cart-page')) { window.location.reload(); return; }
          var rendu = data && data.sections && data.sections['cart-drawer'];
          if (rendu) { appliquerTiroir(rendu, true); } else { refreshDrawer(true); }
        }).catch(function () {
          if (lineEl) lineEl.classList.remove('is-busy');
        });
      }
    });

    /* ---------- Tiroir : choix du motif de la suggestion (V80) ----------
       Toucher une vignette change la photo, le nom et la variante que le
       bouton « + Ajouter » enverra. Rien ne part au serveur : le tiroir
       reste tel quel, seul le formulaire change de pièce. */
    document.addEventListener('click', function (e) {
      var motif = e.target.closest('[data-motif]');
      if (!motif) return;
      var carte = motif.closest('[data-suggest]');
      if (!carte) return;
      carte.querySelectorAll('[data-motif]').forEach(function (m) {
        m.setAttribute('aria-pressed', m === motif ? 'true' : 'false');
      });
      var champ = carte.querySelector('[data-suggest-id]');
      if (champ) champ.value = motif.getAttribute('data-id');
      var nom = carte.querySelector('[data-suggest-name]');
      if (nom) nom.textContent = motif.getAttribute('data-name');
      var img = carte.querySelector('[data-suggest-img]');
      if (img) {
        img.removeAttribute('srcset');
        img.src = motif.getAttribute('data-src');
      }
    });

    /* ---------- Page panier : reprise de la barre de paliers ----------
       Les paliers sont configurés sur la section Tiroir panier, et Liquid
       ne permet pas à une section d'aller lire les réglages d'une autre.
       Plutôt que de dupliquer la configuration — deux endroits à régler,
       donc deux occasions de diverger — on recopie la barre que le tiroir
       a DÉJÀ fait calculer côté serveur : il est rendu sur toutes les
       pages par le layout.

       La page panier se recharge à chaque modification du panier, si bien
       que la copie est toujours celle du dernier rendu serveur. */
    function poserBarrePaliers() {
      var emplacements = document.querySelectorAll('[data-rewards-slot]');
      if (!emplacements.length) return;
      var source = document.querySelector('#CartDrawer .cart-rewards');

      emplacements.forEach(function (emplacement) {
        var ancienPourcent = lirePourcentBarre(emplacement);
        /* On vide avant de reposer : sur la fiche produit le panier change
           sans rechargement, une copie laissée en place afficherait un
           reste à atteindre périmé dès le premier ajout. */
        emplacement.innerHTML = '';
        if (!source) return;

        var copie = source.cloneNode(true);
        /* On enlève ce qui ne doit exister qu'une fois dans la page :
           les identifiants, les ancres de l'éditeur de thème, et le
           marqueur du cadeau orphelin, déjà porté par l'original. */
        copie.removeAttribute('data-gift-orphan');
        copie.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
        copie.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) {
          n.removeAttribute('data-shopify-editor-block');
        });
        emplacement.appendChild(copie);
        animerBarre(emplacement, ancienPourcent);
      });
    }
    poserBarrePaliers();

    /* Au chargement : la page panier est rechargée après chaque
       modification, c'est donc ici qu'un cadeau orphelin est rattrapé. */
    retirerCadeauOrphelin();

    /* ---------- Variantes PDP ---------- */
    var variantJson = document.querySelector('[data-variant-json]');
    if (variantJson) {
      var variants = [];
      try { variants = JSON.parse(variantJson.textContent); } catch (err) { variants = []; }
      var productForm = document.querySelector('form[data-ajax-cart][data-product-form]');
      refreshOptionAvailability(variants);
      document.querySelectorAll('[data-option-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          var selected = [];
          document.querySelectorAll('[data-option-index]').forEach(function (group) {
            var checked = group.querySelector('input:checked, select');
            selected.push(checked ? checked.value : null);
          });
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === selected[i]; });
          });
          if (match && productForm) {
            productForm.querySelector('[name="id"]').value = match.id;
          }
          /* Points Avelyn Club : même calcul que le serveur du club */
          var club = document.querySelector('[data-club-rate]');
          var clubOut = club && club.querySelector('[data-club-points]');
          if (match && clubOut) {
            var rate = parseInt(club.getAttribute('data-club-rate'), 10) || 10;
            clubOut.textContent = (Math.floor(match.price / 100) * rate) + ' points';
          }
          document.querySelectorAll('.swatch, .option-pill').forEach(function (s) {
            var inp = s.querySelector('input');
            s.classList.toggle('is-selected', !!(inp && inp.checked));
          });
          refreshOptionAvailability(variants);
          var label = document.querySelector('[data-selected-option]');
          var first = document.querySelector('[data-option-index] input:checked');
          if (label && first) label.textContent = first.value;
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
